/**
 * register plugins
 */
import { IsArray, IsString } from "@pdfking/tfunc"

export default (
  q: Element | Element[] | string,
  element?: Element
): Element[] => {
  if (IsString(q)) {
    return [...(element || document).querySelectorAll(q)]
  }
  return (IsArray(q) ? q : [q]) as Element[]
}
